<template lang="pug">
app-main-content-layout(title='Stickers')
  template(#actions)
    el-button(
      type="primary"
      @click="$router.push(`/manage-content/media/add-stickers-v2`)"
      color='#1EBEAF'
      size="large").add-new-button
      span Add New
      template(#icon)
        img(src="@/assets/icons/plusIcon.svg" style="width: 20px; height: 20px;")

  div
    div.filter-container
      span.padding-left-20(@click="!loading && headerFilter('ALL')"
      :class="getClass('ALL')" :style="loading ? 'cursor: not-allowed; opacity: 0.7' : ''") All
      span.padding-left-20(@click="!loading && headerFilter('Active')"
        :class="getClass('Approved')" :style="loading ? 'cursor: not-allowed; opacity: 0.7' : ''") Approved
      span.padding-left-20(@click="!loading && headerFilter('Draft')"
      :class="getClass('Pending')" :style="loading ? 'cursor: not-allowed; opacity: 0.7' : ''") Pending
      span.padding-left-20(@click="!loading && headerFilter('Archived')"
      :class="getClass('Archived')" :style="loading ? 'cursor: not-allowed; opacity: 0.7' : ''") Archived
    
    .org-filter-indicator(v-if="selectedOrganization && selectedOrganization.id")
      .container
        .row.align-items-center.py-2
          .col-auto.d-flex.align-items-center
            span.org-filter-label Filtered by organization:
            span.org-filter-name {{ selectedOrganization.name }}
            el-button(type="text" @click="clearOrgFilter" :disabled="loading")
              span Clear
    .container.align-items-center
      .row.align-items-center
        .selected-count
          .row.align-items-center {{selected.length}} selected
            .col-auto()
                  VueMultiselect(
                  v-model="setAs"
                  :multiple="false",
                  :options="setAsOption",
                  :searchable="false",
                  :close-on-select="true",
                  :show-labels="false"
                  :disabled="selected.length === 0"
                  label="label"
                  placeholder="Set as"
                  @select="bulkUpdate(setAs.value)"
                  style="width: 180px;"
                )
        .col-md
            .row.align-items-center
              el-input(
                v-model="state.searchTerm"
                placeholder="Filter Stickers"
                style="width: 200px;"
                @keyup="handleSearchKeyup"
                :disabled="loading"
              ).input-search-filter
                template(#suffix='')
                  img(
                    src="@/assets/icons/searchIcon.svg"
                    style="font-size: 20px; cursor: pointer;"
                    @click="getItems"
                  )
              el-button(
                type="info" 
                v-show="state.searchTerm" 
                @click="clearSearchAndRefresh"
                :disabled="loading"
              ).has-fai.clear-filter-button
                span Clear
              .col-auto()
                VueMultiselect(
                    v-model="state.sortOption"
                    :multiple="false",
                    :options="sortOptions",
                    :searchable="false",
                    :close-on-select="true",
                    :show-labels="false"
                    label="label"
                    placeholder="Sort"
                    @select="handleSortChange"
                    :disabled="loading"
                    style="width: 180px;"
                  )


    el-table(
      :data="items.items"
      @row-click="$router.push(`stickers-v2/${$event.id}`)"
      @selection-change="onCheckboxChange"
      v-loading="loading"
      style="width: 100%"
    ).clickable-rows
      el-table-column(width="40")
        template(#default="scope")

      el-table-column(type="selection" width="55")

      el-table-column(width="150")
        template(#default="scope")
          img(:src="scope.row.url").size-50px.obj-f-c
      el-table-column.table-title(prop="title" label="Title" min-width="200" class="table-title")
        template(#default="scope")
          div.table-title {{scope.row.title}}
      el-table-column(prop="published" label="Type" width="200" class="table-title")
        template(#default="scope")
          .font-medium  Sticker
      el-table-column(prop="published" label="Status" min-width="200" class="table-title")
        template(#default="scope")
          div(:class="getButtonClass(stickerState(scope.row))")
            p {{ stickerState(scope.row) }}
        
  .d-flex.justify-content-between.align-items-center.mt-4(v-if="items.items && items.items.length > 0")
    .page-size.d-flex.align-items-center
      span.pe-2 Items per page:
      el-select(
        v-model="state.pageSize"
        @change="handleSizeChange"
        size="small"
        style="width: 80px; --el-color-primary: #1fbeaf;"
      )
        el-option(
          v-for="size in [20, 30, 50]"
          :key="size"
          :label="size"
          :value="size"
          :style="state.pageSize === size ? { color: '#1fbeaf' } : {}"
        )
    
    .pagination-wrapper.d-flex.justify-content-center
      .simple-pagination.d-flex.align-items-center
        .page-nav.d-flex
          button.page-btn.prev(
            @click="handleCurrentChange(state.currentPage - 1)"
            :disabled="state.currentPage === 1 || loading"
          ) Prev
          .page-numbers.mx-2 {{ state.currentPage }}
          button.page-btn.next(
            @click="handleCurrentChange(state.currentPage + 1)"
            :disabled="!state.hasMoreItems || loading"
          ) Next
        .page-info.ms-3(v-if="items.items.length > 0") 
          | Showing {{ ((state.currentPage - 1) * state.pageSize) + 1 }}-{{ ((state.currentPage - 1) * state.pageSize) + items.items.length }}

  .api-error.text-center.my-5(v-if="state.apiError")
    h3 Error loading stickers
    p {{ state.apiError }}
    el-button(
      @click="getItems"
      class="mt-3"
    ) Retry
</template>
<style>
.page-size {
  display: flex;
  font-weight: 500;
}

.pagination-wrapper {
  margin-top: 20px;
}

.simple-pagination {
  font-size: 16px;
}

.page-btn {
  background: transparent;
  border: 2px solid #1fbeaf;
  border-radius: 4px;
  padding: 5px 12px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.page-btn:hover:not(:disabled) {
  background: var(--el-color-primary-light-7);
}

.page-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.page-numbers {
  display: flex;
  align-items: center;
  font-size: 18px;
}

.page-info {
  color: #666;
  font-size: 14px;
}

.clear-filter-button {
  border: 1px solid lightgray;
  color: black;
  border-radius: 4px;
  padding: 5px 12px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.clear-filter-button:hover {
  background-color: #1fbeaf;
  color: #fff;
}

.api-error {
  color: #f56c6c;
}

.api-error button {
  background-color: #f56c6c;
  color: white;
  border: none;
}

.api-error button:hover {
  background-color: #e45656;
}

.selected-count {
  width: max-content;
}

.org-filter-indicator {
  background-color: #f0f9fb;
  border-top: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
  margin-bottom: 15px;
}

.org-filter-label {
  margin-right: 10px;
  font-weight: 500;
  color: #606266;
}

.org-filter-name {
  font-weight: 600;
  color: #303133;
  margin-right: 15px;
}

</style>
<script>

import {
  reactive, onMounted, defineComponent, ref, watch, computed,
} from 'vue';
import VueMultiselect from 'vue-multiselect';
import DialogAddSticker from './DialogAddSticker.vue';
import shared from '../shared';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';

export default defineComponent({
  name: 'ManageContent_Media_Stickers',
  components: { DialogAddSticker, VueMultiselect },
  setup() {
    const {
      getStickers,
      updateSticker,
      loading,
      dialog,
      saveStickerStatusBulk,
    } = shared();
    const items = reactive({ items: [] });
    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    const selectedOrganization = computed(() => store.getters["organizations/GET_SELECTED_ORGANIZATION"]);

    const state = reactive({
      currentView: 'ALL',
      searchTerm: '',
      pageSize: 20,
      currentPage: 1,
      sortBy: { field: 'CreatedAt', asc: false },
      sortOption: null,
      activeFilters: ['ALL'],
      hasMoreItems: true,
      apiError: null,
    });
    
    const selected = ref([]);
    const ignoreNextUrlChange = ref(false);
    
    const sortOptions = [
      { label: 'Most Recent', value: { field: 'CreatedAt', asc: false } },
      { label: 'Oldest First', value: { field: 'CreatedAt', asc: true } },
      { label: 'Alphabetical (A-Z)', value: { field: 'Title', asc: true } },
      { label: 'Alphabetical (Z-A)', value: { field: 'Title', asc: false } },
    ];

    const setAsOption = [
      { label: 'Approved', value: 'Active' },
      { label: 'Pending', value: 'Pending' },
      { label: 'Archived', value: 'Archived' }
    ];
    const setAs = ref('');
    
    function handleSearchKeyup(event) {
      if (event.key === 'Enter') {
        getItems();
      }
    }
    
    function clearSearchAndRefresh() {
      state.searchTerm = '';
      state.currentPage = 1;
      state.activeFilters = ['ALL'];
      state.currentView = 'ALL';
      getItems();
    }

    function onCheckboxChange(checkedItems) {
      selected.value = checkedItems;
    }

    function handleSortChange(selectedSort) {
      if (selectedSort && selectedSort.value) {
        state.sortBy = selectedSort.value;
        state.sortOption = selectedSort;
        state.currentPage = 1;
        getItems();
      }
    }
    
    function handleSizeChange(newSize) {
      state.pageSize = newSize;
      state.currentPage = 1;
      getItems();
    }

    function handleCurrentChange(newPage) {
      state.currentPage = newPage;
      getItems();
    }

    function getCreator(itm) {
      if (itm.isSpotlight) {
        return 'Spotlight';
      }
      if (itm.entity === 'Organization') {
        return itm.organization.name;
      }
      return itm.creatorTitle;
    }

    function stickerState(itm) {
      switch (itm.status) {
        case 'Active':
          return 'Approved';
        case 'Draft':
        case null:
        case 'Pending':
          return 'Pending';
        case 'Archived':
          return 'Archived';
        default:
          return 'Pending';
      }
    }

    function getClass(currentItem) {
      if (currentItem === state.currentView) {
        return 'filter-active';
      }
      return 'filter-inactive';
    }

    function getButtonClass(currentItem) {
      switch (currentItem) {
        case 'Approved':
          return 'approved-button';
        case 'Pending':
        case 'Draft':
        case null:
          return 'pending-button';
        case 'Archived':
          return 'archived-button';
        default:
          return 'pending-button';
      }
    }

    function headerFilter(filterBy) {
      state.currentView = filterBy;
      if (filterBy === 'ALL') {
        state.activeFilters = ['ALL'];
      } else {
        state.activeFilters = [filterBy];
      }
      
      state.currentPage = 1;
      getItems();
    }

    async function getItems() {
      try {
        loading.value = true;
        state.apiError = null;
        
        const skip = (state.currentPage - 1) * state.pageSize;
        const orderBy = state.sortBy ? state.sortBy.field : 'CreatedAt';
        const orderAsc = state.sortBy ? state.sortBy.asc : false;
        
        const organizationId = selectedOrganization.value ? selectedOrganization.value.id : '';
        
        const result = await getStickers(
          state.pageSize,
          skip,
          state.searchTerm,
          state.activeFilters,
          orderBy,
          orderAsc,
          organizationId
        );
        
        updateUrlParams();
        
        if (!result) {
          items.items = [];
          state.hasMoreItems = false;
          state.apiError = 'API returned undefined or null result';
          return;
        }
        
        items.items = result;

        if (items.items.length === state.pageSize) {
          const nextPageResult = await getStickers(
            1,
            skip + state.pageSize,
            state.searchTerm,
            state.activeFilters,
            orderBy,
            orderAsc,
            organizationId
          );
          
          state.hasMoreItems = nextPageResult && nextPageResult.length > 0;
        } else {
          state.hasMoreItems = false;
        }
      } catch (err) {
        console.error('Error fetching stickers:', err);
        state.apiError = 'Error loading stickers. Please try again later.';
      } finally {
        loading.value = false;
      }
    }

    function updateUrlParams() {
      ignoreNextUrlChange.value = true;
      
      const query = {};
      
      if (state.searchTerm) {
        query.search = state.searchTerm;
      }
      
      if (state.activeFilters.length > 0 && state.activeFilters[0] !== 'ALL') {
        query.filter = state.activeFilters[0];
      }
      
      if (state.sortBy) {
        query.sort = state.sortBy.field;
        if (state.sortBy.asc) {
          query.dir = 'asc';
        } else {
          query.dir = 'desc';
        }
      }
      
      if (state.currentPage > 1) {
        query.page = state.currentPage;
      }
      
      if (state.pageSize !== 20) {
        query.size = state.pageSize;
      }
      
      router.replace({ query }).catch(() => {});
      
      setTimeout(() => {
        ignoreNextUrlChange.value = false;
      }, 100);
    }
    
    function loadParamsFromUrl() {
      const query = route.query;
      
      if (query.search) {
        state.searchTerm = query.search.toString();
      } else {
        state.searchTerm = '';
      }
      
      if (query.filter) {
        const filterValue = query.filter.toString();
        if (['ALL', 'Approved', 'Pending', 'Archived'].includes(filterValue)) {
          state.activeFilters = [filterValue];
          state.currentView = filterValue;
        } else {
          state.activeFilters = ['ALL'];
          state.currentView = 'ALL';
        }
      } else {
        state.activeFilters = ['ALL'];
        state.currentView = 'ALL';
      }
      
      if (query.sort) {
        const sortField = query.sort.toString();
        if (['CreatedAt', 'Title'].includes(sortField)) {
          const sortDir = query.dir === 'asc';
          state.sortBy = { field: sortField, asc: sortDir };
          
          state.sortOption = sortOptions.find(
            option => option.value.field === sortField && option.value.asc === sortDir
          );
        } else {
          state.sortBy = { field: 'CreatedAt', asc: false };
          state.sortOption = sortOptions.find(
            option => option.value.field === 'CreatedAt' && option.value.asc === false
          );
        }
      } else {
        state.sortBy = { field: 'CreatedAt', asc: false };
        state.sortOption = sortOptions.find(
          option => option.value.field === 'CreatedAt' && option.value.asc === false
        );
      }
      
      if (query.page) {
        try {
          const page = parseInt(query.page.toString(), 10);
          if (page > 0) {
            state.currentPage = page;
          } else {
            state.currentPage = 1;
          }
        } catch (e) {
          state.currentPage = 1;
        }
      } else {
        state.currentPage = 1;
      }
      
      if (query.size) {
        try {
          const size = parseInt(query.size.toString(), 10);
          if ([20, 30, 50].includes(size)) {
            state.pageSize = size;
          } else {
            state.pageSize = 20;
          }
        } catch (e) {
          state.pageSize = 20;
        }
      } else {
        state.pageSize = 20;
      }
    }

    async function bulkUpdate(type) {
      const bulkStickers = [];
      selected.value.forEach((element) => {
        const item = { id: element.id, status: type };
        bulkStickers.push(item);
      });
      await saveStickerStatusBulk(bulkStickers);
      await getItems();
      setAs.value = '';
    }

    async function saveItem(input) {
      await updateSticker(input);
      await getItems();
    }

    watch(
      () => route.query,
      () => {
        if (ignoreNextUrlChange.value) {
          return;
        }
        
        loadParamsFromUrl();
        getItems();
      },
      { deep: true }
    );

    watch(
      () => selectedOrganization.value,
      (newOrg, oldOrg) => {
        if (newOrg?.id !== oldOrg?.id) {
          state.currentPage = 1;
          getItems();
        }
      }
    );

    function clearOrgFilter() {
      store.dispatch('organizations/SET_SELECTED_ORGANIZATION', null);
      state.currentPage = 1;
      getItems();
    }

    onMounted(async () => {
      await store.dispatch('sticker/RESET_TO_DEFAULT');
      
      state.sortOption = sortOptions.find(
        option => option.value.field === state.sortBy.field && option.value.asc === state.sortBy.asc
      );
      
      loadParamsFromUrl();
      
      await getItems();
    });

    return {
      items,
      loading,
      dialog,
      state,
      selected,
      sortOptions,
      setAsOption,
      setAs,
      selectedOrganization,
      getCreator,
      saveItem,
      stickerState,
      headerFilter,
      getClass,
      clearSearchAndRefresh,
      handleSortChange,
      onCheckboxChange,
      bulkUpdate,
      getButtonClass,
      handleSizeChange,
      handleCurrentChange,
      handleSearchKeyup,
      updateUrlParams,
      loadParamsFromUrl,
      clearOrgFilter,
    };
  },
});
</script>
